import { Injectable } from '@angular/core';
import { HttpHeaders, HttpClient } from '@angular/common/http';
import { GLOBAL } from '../global';
import { GenericRequestReports } from '../domain/generic-request-reports';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class MovimientoService {

  urlBase: string;
  httpOptions = {
    headers: new HttpHeaders({ 'Content-Type': 'application/json' })
  };

  /**
   * @author Daniel Pareja Londoño
   * @version 2018-11-25
   * @param httpClient
   */
  constructor(private httpClient: HttpClient) {
    this.urlBase = GLOBAL.URL_SIGAMOS + 'sicaMovimiento';
  }

  /**
   * @author Daniel Pareja Londoño
   * @version 2018-11-25
   * @param genericRequestReports 
   */
  reportSalesPeriodTime(genericRequestReports: GenericRequestReports): Observable<any> {
    return this.httpClient.post(this.urlBase + '/reportSalesPeriodTime', genericRequestReports, this.httpOptions);
  }

}
